import styled from 'styled-components';
import { Th } from 'react-super-responsive-table';
import { colors, MediaQuery } from '../../../theme/style-helpers';
import ArrowDown from '../../../assets/icons/ArrowDown.svg';
import { P } from '../../../theme/typographySitecore';
import ChevronRightBlack from '../../../assets/icons/ChevronRightBlack.svg';
import ChevronRightOrange from '../../../assets/icons/ChevronRightOrange.svg';
import ChevronLeftBlack from '../../../assets/icons/ChevronLeftBlack.svg';
import ChevronLeftOrange from '../../../assets/icons/ChevronLeftOrange.svg';

export const NoResults = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  letter-spacing: 0em;
  text-align: center;
  margin-bottom: 85px;
`;

export const PaginationContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: center;
  grid-gap: 32px;
  margin-bottom: 40px;

  button:first-child,
  button:last-child {
    ${MediaQuery.xSmall`
      display: none;
    `}
  }
`;

export const PageNumber = styled.button`
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: center;
  border: none;
  background-color: transparent;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  ${({ selected }) =>
    selected
    && `
    font-weight: 700;
    border-bottom: 2px solid ${colors.BRAND_ORANGE};
  `};
`;

export const TableContainer = styled.div`
  width: 100%;
  margin-top: -42px;
  overflow-x: auto;
  transform: rotateX(180deg);
  -ms-transform: rotateX(180deg); /* IE 9 */
  -webkit-transform: rotateX(180deg); /* Safari and Chrome */

  > table,
  ${PaginationContainer}, ${NoResults} {
    transform: rotateX(-180deg);
    -ms-transform: rotateX(-180deg); /* IE 9 */
    -webkit-transform: rotateX(-180deg); /* Safari and Chrome */

    .sticky {
      position: -webkit-sticky;
      position: sticky;

      &.column-0 {
        left: 0;
        width: 85px;
        z-index: 2;
      }

      &.column-1 {
        left: 85px;
        z-index: 1;
      }
    }
  }

  &::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 1px 1px ${colors.COOL_GREY};
    border-radius: 100px;
    border: 1px solid transparent;

    ${MediaQuery.medium`
        margin-left: 12px;
        margin-right: 12px;
    `}
  }

  &::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 8px 8px ${colors.BRAND_ORANGE};
    border: 2px solid transparent;
    border-radius: 100px;
  }

  &::-webkit-scrollbar-button:horizontal:decrement {
    background-image: url(${ChevronLeftOrange});
    background-size: 14px 14px;
    background-position: center center;
    background-repeat: no-repeat;

    &:hover {
      background-image: url(${ChevronLeftBlack});
    }
  }

  &::-webkit-scrollbar-button:horizontal:increment {
    background-image: url(${ChevronRightOrange});
    background-size: 14px 14px;
    background-position: center center;
    background-repeat: no-repeat;

    &:hover {
      background-image: url(${ChevronRightBlack});
    }
  }

  table {
    transform: rotateX(-180deg);
    -ms-transform: rotateX(-180deg); /* IE 9 */
    -webkit-transform: rotateX(-180deg); /* Safari and Chrome */
    margin-bottom: 16px;
    min-width: 100%;

    thead {
      background-color: ${colors.LIGHT_GREY};
      border-radius: 1px;

      tr {
        th {
          background-color: ${colors.GREY_LIGHT};
          font-weight: 500;
        }

        &:hover {
          th {
            background-color: ${colors.GREY_LIGHT};
          }
        }
      }
    }

    td,
    th {
      padding: 16px 16px;
      white-space: nowrap;
    }

    tbody tr {
      border-bottom: 1px solid ${colors.COOL_GREY};

      td {
        background-color: ${colors.WHITE};
      }

      &:hover {
        cursor: pointer;

        td {
          background-color: ${colors.GREY_LIGHT};
        }
      }
    }

    th {
      font-size: 14px;
      font-weight: 600;
      line-height: 19px;
      letter-spacing: 0em;
      cursor: pointer;

      &:first-child {
        width: 90px;
      }
    }
  }

  .dropdown {
    .btn {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 0;
      padding: 15px 20px;
      font-size: 1.4rem;
      color: ${colors.BLACK} !important;
      background-color: ${colors.WHITE
        + colors.OPACITY_00_ALPHA_HEX_SUFFIX} !important;
      border-color: ${colors.BLACK};

      &:hover {
        background-color: ${colors.WHITE};
        color: ${colors.BLACK};
      }
    }

    .dropdown-menu {
      top: 0;
      left: 0;
      right: 0;
      width: max-content;
      margin-top: 0;
      border-color: ${colors.BLACK};
      border-radius: 0;
      font-size: 1.4rem;

      .dropdown-item {
        white-space: normal;
        margin: 10px 0;
      }
    }
  }

  .no-word-break {
    display: flex;
    align-items: center;
  }
  
  .wrapText{
    white-space: wrap;
  }
`;

export const Icon = styled.img`
  transform: rotate(0);
  transition: all 0.3s;
  cursor: pointer;
  width: 36px;
  height: 36px;

  &.active {
    transform: rotate(180deg);
    transition: all 0.3s;
  }
`;
export const TableHeader = styled(Th)`
  border-bottom: none;
`;
export const StyledTable = styled.table`
  margin-bottom: 16px;
  min-width: 100%;

  thead {
    background-color: ${colors.LIGHT_GREY};
    border-radius: 1px;

    tr {
      th {
        background-color: ${colors.GREY_LIGHT};
        font-weight: 500;
      }

      &:hover {
        th {
          background-color: ${colors.GREY_LIGHT};
        }
      }
    }
  }

  td,
  th {
    padding: 16px 16px;
    white-space: nowrap;
  }

  tbody tr {
    border-bottom: 1px solid ${colors.COOL_GREY};

    td {
      background-color: ${colors.WHITE};
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
      letter-spacing: 0em;
    }

    &:hover {
      cursor: pointer;

      td {
        background-color: ${colors.GREY_LIGHT};
      }
    }
  }

  th {
    font-size: 14px;
    font-weight: 600;
    line-height: 19px;
    letter-spacing: 0em;
    cursor: pointer;

    &:first-child {
      width: 90px;
    }

    img {
      margin-left: 8px;
    }
  }

  &.actions-scroll .dropdown .dropdown-menu {
      max-height: 200px;
      overflow-y: auto;
    }
  }
`;

export const TableDataCell = styled.td`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  vertical-align: ${({ topAligned }) => (topAligned ? 'top' : 'baseline')};
  text-align: ${({ textAlignCenter }) => (textAlignCenter ? 'center' : 'left')};

  span {
    font-weight: 600;
    line-height: 19px;
  }
`;

export const FilterText = styled.label`
  margin-bottom: 2rem;
  margin-right: 3rem;
  font-size: 1.4rem;
  line-height: 2.1rem;
  display: inline-flex;
  align-items: center;
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  user-select: none;

  .checkbox {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;

    &:checked ~ .checkmark {
      background-color: ${colors.BRAND_ORANGE};

      &:after {
        display: block;
        left: 5px;
        top: 1px;
        width: 7px;
        height: 11px;
        border: solid ${colors.WHITE};
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
      }
    }
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 21px;
    width: 21px;
    border: 1.5px solid ${colors.BLACK};
    background-color: ${colors.WHITE};
    border-radius: 2px;

    &:after {
      content: "";
      position: absolute;
      display: none;
    }
  }
`;

export const FilterLabel = styled.p`
  font-weight: 600;
  margin-bottom: 2rem;
  font-size: 1.6rem;
  line-height: 2.1rem;
`;

export const PrimaryButton = styled.button`
  background-color: ${colors.DARK_GREY};
  font-style: normal;
  position: relative;
  font-weight: 500;
  font-size: 1.6rem;
  line-height: normal;
  text-align: center;
  color: ${colors.COOL_GREY};
  padding: 16px 56px;
  border: 1px solid ${colors.DARK_GREY};
  border-radius: 3px;
  margin-left: 0;
  margin-bottom: 10px;
  width: 100%;
  cursor: pointer;
  order: 0;

  &.min-width {
    min-width: 300px;
  }

  ${MediaQuery.medium`
      width: auto;
      margin-left: 16px;
      margin-bottom: 0;
      order: 1;
  `}

  &.submit, &.active {
    background-color: ${colors.BLACK};

    &:hover {
      background-color: ${colors.BRAND_ORANGE};
      color: ${colors.BLACK};
      border-color: ${colors.BRAND_ORANGE};
    }
  }
`;

export const SecondaryButton = styled.button`
  background-color: ${colors.WHITE};
  position: relative;
  font-style: normal;
  font-weight: 500;
  font-size: 1.6rem;
  line-height: normal;
  text-align: center;
  color: ${colors.BLACK};
  padding: 16px 56px;
  border: 1px solid ${colors.BLACK};
  border-radius: 3px;
  margin-left: 0;
  width: 100%;
  order: 1;
  cursor: pointer;

  &.min-width {
    min-width: 300px;
  }

  ${MediaQuery.medium`
      width: auto;
      margin-left: 16px;
      order: 0;
  `}

  &:hover {
    border-color: ${colors.BRAND_ORANGE};
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
`;

export const TableHeaderLabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const TableHeaderLabel = styled(P)`
  margin: 0px !important;
  font-size: 14px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
`;

export const ArrowDownIcon = styled.img.attrs(() => ({ src: ArrowDown }))`
  max-width: initial;
`;
